import React, { Component } from "react";
import Pagination from "react-js-pagination";
import "./PlansFooter.css";

export default class PlansFooter extends Component {
  render() {
    return (
        <div className="styl-pagination">
          <Pagination
            prevPageText={<i className="fas fa-chevron-left"></i>}
            nextPageText={<i className="fas fa-chevron-right"></i>}
            activePage={this.props.activePage}
            itemsCountPerPage={this.props.itemsCountPerPage}
            totalItemsCount={this.props.totalItemsCount}
            hideFirstLastPages
            disabledClass="true"
            itemClass="page-item"
            activeClass={
              this.props.activePage.toString().length === 1
                ? "active-single-item"
                : "active-double-item"
            }
            onChange={this.props.handlePageChange}
          />
          <label className="showpage-styl">
            Showing {this.props.plans.length} of {this.props.totalItemsCount}{" "}
            Plans
          </label>
        </div>
    );
  }
}
